<template>
  <div id="question">
    <!-- 弹出层 -->
    <demonstration v-if="demShow" @onOff="typeShow"></demonstration>
    <contact v-if="conShow" @onOff="typeShow"></contact>
    <feedback ref="ref_feedback" v-if="feedbackShow" @onOff="typeShow" @selectQuestion="selectQuestion"
              @changeFeedbackShow="changeFeedbackShow" :props_questionTitle="feedbackMessage"></feedback>
    <videos v-if="videosShow" @onOff="typeShow"></videos>
    <!-- 主体内容 -->
    <div class="content">
      <div class="search">
        <div class="search-title">您好！有什么可以帮到您？</div>
        <div class="search-wrap">
          <div class="search-question" v-show="isSearchQuestion">
            <search-question
              v-show="feedbackMessage"
              @feedbackProblem="feedbackProblem"
              :searchList="searchList"
              :isSearchListBlank="isSearchListBlank"
              :feedbackMessage="feedbackMessage"
              :selectedIndex="selectSearchListIndex"></search-question>
          </div>
          <div class="search-input">
            <input type="text" placeholder="请输入您想要反馈的问题"
                   v-click-outside="closeSearchQuestion"
                   @click="showSearchQuestion"
                   v-model="feedbackMessage"
                   @keydown.up.prevent="handle_selecteQuestion(-1)"
                   @keydown.down.prevent="handle_selecteQuestion(1)"
                   @keydown.enter.prevent="jump_questionDetail_page">
          </div>
        </div>
      </div>
    </div>
    <div class="question-wrap">
      <div class="question">
        <div class="question-title">
          <div class="left-title"
               @click="handler_getHotQuestionList"
               :class="[titleList[0].isSelected ? 'question-title-active' : '']">{{ titleList[0].value }}</div>
          <div class="right-title"
               @click="handler_getMyQuestionList"
               :class="[titleList[1].isSelected ? 'question-title-active' : '']">{{ titleList[1].value }}</div>
        </div>
        <div class="question-list" :class="[questionList.length < 9 ? 'order' : '']">
          <div class="item" v-for="item in questionList" :key="item.id" @click="getQuizDetail(item.id)">
            <div class="item-center">
              <span :class="iconClass"></span>
              <div class="item-text">{{ item.topic }}</div>
              <div class="andmore"></div>
            </div>
          </div>
        </div>
        <div class="more" @click="getMoreQuestion">
          更多问题
          <div class="icon-more"></div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <footer>
      <div class="footer-wrap">
        <div class="footer-title" id="reservation">客户支持</div>
        <div class="help">
          <div class="help-item" v-for="support in supportList" :key="support.id" @click="helpSupport(support.id)">
            <div class="icon-wrap"></div>
            <div class="help-text">{{ support.text }}</div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import demonstration from '../demonstration/demonstration'
  import contact from '../contact/contact'
  import searchQuestion from '../search-question/search-question'
  import feedback from '../feedback/feedback'
  import videos from '../videos/videos'
  import {mapGetters, mapActions} from 'vuex'
  import clickOutside from '../../directives/click-outside/index'

  export default {
    name: 'question',
    components: {
      demonstration,
      contact,
      searchQuestion,
      feedback,
      videos
    },
    data() {
      return {
        isQuestionLoading: false,
        selectQuestionIndex: 0,
        selectSearchListIndex: 0,
        supportList: [
          {id: 0, text: '预约演示'},
          {id: 1, text: '视频教学'},
          {id: 2, text: '联系我们'}
        ],
        demShow: false,
        conShow: false,
        feedbackShow: false,
        videosShow: false,
        questionList: [],
        isSearchQuestion: false,
        feedbackMessage: '',
        searchTime: null,
        searchList: [],
        titleList: [
          {
            value: '热门问题',
            isSelected: true
          },
          {
            value: '我的反馈',
            isSelected: false
          }
        ]
      }
    },
    directives: {
      clickOutside
    },
    created() {
      if (this.getUserId !== '' && this.getUserId !== undefined) {
        let params = {
          currentPage: 0,
          pageSize: 9
        }
        this.action_getHotQuestionPage(params).then(res => {
          if (res.erpCode === '000') {
            this.questionList = res.erpData.pageItem
          } else {
            this.showMessage(res.erpMsg || '获取问题列表出错')
          }
        })
      }
    },
    computed: {
      ...mapGetters([
        'getCommentPageSize',
        'getUserId'
      ]),
      isSearchListBlank() {
        if (this.feedbackMessage) {
          return this.searchList.length === 0
        }
        return true
      },
      iconClass() {
        return [this.titleList[0].isSelected ? 'icon-hot-question' : 'icon-my-question']
      }
    },
    methods: {
      ...mapActions([
        'action_getHotQuestionPage',
        'action_getUserQuestionPage',
        'action_getQuestionDetails',
        'action_getQuestionMessagePage',
        'action_getRelatedQuizPage',
        'action_searchQuestionPage',
        'setRelatedQuizDetail',
        'setQuestionDetail',
        'setMessageDetail'
      ]),
      handle_selecteQuestion(n) {
        let index = this.selectSearchListIndex + n
        // 键盘上下键都能实现循环选择
        if (index < 0) {
          index = this.searchList.length - 1
        } else if (index >= this.searchList.length) {
          index = 0
        }
        this.selectSearchListIndex = index
      },
      jump_questionDetail_page() {
        // 没有搜索结果则不跳转页面
        if (!this.searchList.length) {
          return false
        }
        let id = this.searchList[this.selectSearchListIndex].id
        this.$router.push({path: '/help', query: {questionId: id, questionHash: Math.random()}})
      },
      searchQuiz() {
        let params = {
          keyword: this.feedbackMessage,
          currentPage: 0,
          pageSize: 6
        }
        this.action_searchQuestionPage(params).then(res => {
          if (res.erpCode === '000') {
            this.searchList = res.erpData.pageItem
            this.selectSearchListIndex = 0
          } else {
            this.showMessage(res.erpMsg || '搜索问题出错')
          }
        })
      },
      helpSupport(id) {
        switch (id) {
          case 0:
            this.demShow = !this.demShow
            break
          case 1:
            this.videosShow = !this.videosShow
            break
          case 2:
            this.conShow = !this.conShow
            break
        }
      },
      typeShow(type) {
        switch (type) {
          case 'dem':
            this.demShow = !this.demShow
            break
          case 'con':
            this.conShow = !this.conShow
            break
          case 'feedback':
            this.feedbackShow = !this.feedbackShow
            break
          case 'videos':
            this.videosShow = !this.videosShow
            break
        }
      },
      showSearchQuestion() {
        this.isSearchQuestion = true
      },
      closeSearchQuestion() {
        this.isSearchQuestion = false
      },
      feedbackProblem() {
        this.isSearchQuestion = false
        this.feedbackShow = true
      },
      changeFeedbackShow() {
        this.feedbackShow = false
      },
      getMoreQuestion() {
        let label = Number(this.titleList[1].isSelected)
        this.$router.push({name: 'help', params: {label}})
      },
      getQuizDetail(id) {
        let label = Number(this.titleList[1].isSelected)
        this.$router.push({path: '/help', query: {questionId: id, label: label, questionHash: Math.random()}})
      },
      selectQuestion(id) {
        this.feedbackShow = false
        this.$router.push({path: '/help', query: {questionId: id, questionHash: Math.random()}})
      },
      initHotQuestionList() {
        if (this.isQuestionLoading) {
          return false
        }
        let params = {
          currentPage: 0,
          pageSize: 9
        }
        this.isQuestionLoading = true
        this.action_getHotQuestionPage(params).then(res => {
          this.isQuestionLoading = false
          if (res.erpCode === '000') {
            this.questionList = res.erpData.pageItem
            this.titleList[0].isSelected = true
            this.titleList[1].isSelected = false
          } else {
            let msg = res.erpMsg || '获取问题列表失败'
            this.$message({
              showClose: true,
              message: msg,
              type: 'warning'
            })
          }
        })
      },
      initMyQuestionList() {
        if (this.isQuestionLoading) {
          return false
        }
        let params = {
          currentPage: 0,
          pageSize: 9
        }
        this.isQuestionLoading = true
        this.action_getUserQuestionPage(params).then(res => {
          this.isQuestionLoading = false
          if (res.erpCode === '000') {
            this.questionList = res.erpData.pageItem
            this.titleList[0].isSelected = false
            this.titleList[1].isSelected = true
          } else {
            let msg = res.erpMsg || '获取问题列表失败'
            this.$message({
              showClose: true,
              message: msg,
              type: 'warning'
            })
          }
        })
      },
      handler_getHotQuestionList() {
        this.initHotQuestionList()
      },
      handler_getMyQuestionList() {
        this.initMyQuestionList()
      }
    },
    watch: {
      feedbackMessage(val) {
        clearTimeout(this.searchTime)
        this.searchTime = setTimeout(() => {
          if (val !== '') {
            this.searchQuiz()
          }
        }, 500)
      },
      getUserId(val) {
        if (val !== '' && val !== undefined) {
          this.initHotQuestionList()
        }
      }
    }
  }
</script>

<style scoped>
  ::-webkit-input-placeholder { /* WebKit browsers */
    font-size: 18px;
    color: #CCCCCC;
    text-indent: 48px;
    letter-spacing: -0.43px;
  }

  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    font-size: 18px;
    color: #CCCCCC;
    text-indent: 48px;
    letter-spacing: -0.43px;
  }

  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    font-size: 18px;
    color: #CCCCCC;
    text-indent: 48px;
    letter-spacing: -0.43px;
  }

  :-ms-input-placeholder { /* Internet Explorer 10+ */
    font-size: 18px;
    color: #CCCCCC;
    text-indent: 48px;
    letter-spacing: -0.43px;
  }

  #question {
    width: 100%;
    margin: 0 auto;
  }

  /* content */
  .content, .question-wrap {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
  }

  .content {
    background: #FBFDFF;
    width: 100%;
    min-width: 1280px;
    height: 450px;
  }

  .search {
    width: 82%;
    height: 450px;
    background: #FAFDFF url("../../icons/image/bigback.png") no-repeat 0 3px;
    background-size: 100% 100%;
  }

  .search-wrap {
    position: relative;
    z-index: 99;
  }

  .search-question {
    position: absolute;
    left: 50%;
    top: 56px;
    transform: translate(-50%, 0);
  }

  .search-title {
    height: 55px;
    margin-top: 104px;
    font-family: PingFangSC-Light, 'Hiragino Sans GB', 'microsoft yahei', arial, sans-serif;
    font-size: 42px;
    color: #585858;
    text-align: center;
    line-height: 55px;
    letter-spacing: 0;
  }

  .search-input {
    width: 718px;
    margin: 41px auto 0;
  }

  .search-input input {
    width: 718px;
    height: 48px;
    border: 1px solid #CCCCCC;
    border-radius: 100px;
    font-size: 18px;
    color: #333;
    line-height: 48px;
    text-indent: 48px;
    outline: none;
    background: #FFFFFF url("../../icons/question.svg") no-repeat 17px center;
  }

  .question-wrap {
    min-width: 1280px;
    max-width: 1400px;
    margin: 0 auto;
  }

  .question {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 82%;
    text-align: center;
  }

  .question-title {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    height: 42px;
    margin-top: 40px;
    font-family: PingFangSC-Light, 'Hiragino Sans GB', 'microsoft yahei', arial, sans-serif;
    font-size: 25px;
    color: #999999;
  }

  .left-title {
    position: relative;
    padding-right: 15px;
    cursor: pointer;
  }

  .left-title:after {
    position: absolute;
    content: "";
    right: 0;
    top: 50%;
    height: 17px;
    width: 1px;
    transform: translateY(-40%);
    background: #efefef;
  }

  .right-title {
    padding-left: 15px;
    cursor: pointer;
  }

  .question-title-active {
    font-size: 30px;
    color: #333333;
  }

  .question-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 60px;
  }

  .item {
    display: flex;
    align-items: flex-end;
    width: 320px;
    height: 126px;
    border-bottom: 1px solid #ccc;
    text-align: left;
    cursor: pointer;
  }

  .order {
    justify-content: flex-start;
  }

  .order .item {
    margin-right: calc(50% - 490px);
  }

  .order .item:nth-of-type(3n) {
    margin-right: 0;
  }

  .item-center {
    display: flex;
    height: 56px;
    margin-bottom: 20px;
  }

  .item-text {
    width: 272px;
    font-size: 20px;
    color: #777777;
    line-height: 28px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .andmore {
    width: 14px;
    height: 28px;
    background: url("../../icons/right-arrow.svg") no-repeat right center;
  }

  .last-text {
    width: 274px;
  }

  .icon-hot-question {
    width: 17px;
    height: 10px;
    margin-top: 10px;
    margin-right: 8px;
    background: url("../../icons/hot-question-arrow.svg") no-repeat;
  }
  .icon-my-question {
    width: 17px;
    height: 17px;
    margin-top: 6px;
    margin-right: 8px;
    background: url("../../icons/icon_circle_question_blue.svg") no-repeat;
    background-size: cover;
  }

  .more {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 24px;
    margin: 41px 0 35px;
    font-size: 17px;
    color: #4A90E2;
    line-height: 24px;
    cursor: pointer;
  }

  .icon-more {
    width: 16px;
    height: 16px;
    margin-top: 4px;
    margin-left: 9px;
    background: #fff url("../../icons/more-question.svg") no-repeat;
  }

  /* footer */
  footer {
    width: 100%;
    min-width: 1280px;
    height: 474px;
    background: #FAFDFF;
  }

  .footer-wrap {
    width: 72%;
    min-width: 930px;
    max-width: 1100px;
    margin: 0 auto;
  }

  .footer-title {
    padding-top: 40px;
    font-family: PingFangSC-Light, 'Hiragino Sans GB', 'microsoft yahei', arial, sans-serif;
    font-size: 30px;
    color: #333333;
    text-align: center;
  }

  .help {
    display: flex;
    justify-content: space-between;
    margin: 60px auto 124px;
  }

  .help-item {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 227px;
    height: 208px;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
  }

  .help-item:nth-child(1) {
    background: #fff url("../../icons/reservation.svg") no-repeat 89px 48px;
  }

  .help-item:nth-child(2) {
    background: #fff url("../../icons/video-teaching.svg") no-repeat 92px 54px;
  }

  .help-item:nth-child(3) {
    background: #fff url("../../icons/contact-us.svg") no-repeat 89px 45px;
  }

  .icon-wrap {
    display: flex;
    align-items: center;
    height: 56px;
    margin-top: 46px;
  }

  .help-text {
    align-self: flex-end;
    flex-basis: 100%;
    margin-bottom: 44px;
    font-size: 20px;
    color: #4A90E2;
    text-align: center;
    letter-spacing: -0.48px;
  }
</style>



// WEBPACK FOOTER //
// src/components/question/question.vue